export const titleCase = (value) => value.toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

export const soundex = (name) => {
    const code = [name[0].toUpperCase()];
    const mappings = '01230120022455012623010202';

    for (let index = 1; index < name.length && code.length <= 3; index++) {
        const characterIndex = name[index].toUpperCase().charCodeAt(0) - 65;

        if (characterIndex >= 0 && characterIndex <= 25) {
            const mapping = mappings[characterIndex];

            if (mapping !== '0' && mapping !== code[code.length - 1]) {
                code.push(mapping);
            }
        }
    }

    while (code.length <= 3) {
        code.push('0');
    }

    return code.join('');
};

export const soundexWithSpaces = (input) => input
    .split(' ')
    .map(word => soundex(word))
    .join(' ');
